import { Component, ElementRef, ViewChild } from '@angular/core';
import { LoggerEvent, LoggerProvider } from '../../providers/logger/logger';

@Component({
  selector: 'rmt-footer',
  templateUrl: 'rmt-footer.html'
})
export class RmtFooterComponent {
  @ViewChild('overlay', { read: ElementRef }) overlay: any;
  initRetries = 10;

  constructor() {
  }

  ngAfterViewInit() {
    this.resize(true);
  }

  ngOnChanges() {
    this.resize();
  }

  resize(init = false) {
    window.requestAnimationFrame(() => {
      if (this.overlay && this.overlay.nativeElement && this.overlay.nativeElement.parentNode && this.overlay.nativeElement.parentNode.parentNode) {
        const page = this.overlay.nativeElement.parentNode.parentNode;
        const scrolls = page.getElementsByClassName('scroll-content');
        if (scrolls && scrolls.length === 1)
          scrolls[0].style.paddingBottom = this.overlay.nativeElement.offsetHeight + 'px';

        // sometimes it takes a bit longer until the footer elements are rendered
        if (init && this.initRetries > 0 && this.overlay.nativeElement.children && this.overlay.nativeElement.children.length === 0) {
          this.initRetries--;
          window.requestAnimationFrame(() => {
            this.resize(true);
          });
        }
        else if (this.initRetries === 0)
          LoggerProvider.warning(this, LoggerEvent.ComponentException, 'Failed to initialize footer properly');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-footer/rmt-footer.ts